<template>
  <div
    class="ScaleBox"
    ref="ScaleBox"
    :style="{
      width: width + 'px',
      height: height + 'px',
      transform: 'scale('+scale+') translate(-50%, -50%)'
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ScaleBox',
  props: {},
  data () {
    return {
      scale: 0,
      width: 1920,
      height: 970,
      appid:'',
      adjust:''
    }
  },
  mounted () {
    this.appid = this.getUrlParam('appid') || this.$route.query.appid
    this.adjust = this.getUrlParam('adjust') || this.$route.query.adjust
    if(!this.appid){ //区能力中心临时处理
      let gotos=localStorage.getItem('gotourl')
      console.log(gotos)
      this.appid=gotos?gotos.indexOf('f8fb172eeeae0a')>-1:false
    }
    this.setScale()
    window.addEventListener('resize', this.debounce(this.setScale))
  },
  methods: {
    getScale () {
      let { width, height } = this
      if (window.innerHeight == 1080 && window.innerWidth >= 1920) {
        height = window.innerHeight
        this.height = window.innerHeight
      } else {
        let h = 970
        if (this.appid) {
          h = 1113  // 区能力中心的尺寸2208*1280
        }
        if(this.adjust){
          h = this.adjust*1
        }
        this.height = h
        height = h
      }
      const wh = window.innerHeight / height
      const ww = window.innerWidth / width
      return ww < wh ? ww : wh
    },
    setScale () {
      this.scale = this.getScale()
    },
    debounce (fn, delay) {
      const delays = delay || 500
      let timer
      return function () {
        const th = this
        const args = arguments
        if (timer) {
          clearTimeout(timer)
        }
        timer = setTimeout(function () {
          timer = null
          fn.apply(th, args)
        }, delays)
      }
    },
    getUrlParam (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      var url= window.location.search||window.location.hash
      var r = url.substr(1).match(reg)
      if (r != null) return decodeURI(r[2])
      return null
    }
  }
}
</script>

<style scoped>
.ScaleBox {
  position: absolute;
  display: flex;
  flex-direction: column;
  transform-origin: 0 0;
  left: 50%;
  top: 50%;
  transition: 0.2s;
  z-index: 999;
}
</style>




// WEBPACK FOOTER //
// src/components/scaleBox.vue